/**
 * Last view the user actually opened, per tab and campaign.
 * The tab record can still say Flow when a switch happens before that write
 * lands. This remembers the click itself.
 */
const memory = new Map();

function keyFor(tabId, campaignId) {
  if (!tabId || !campaignId) return null;
  return `${tabId}:${campaignId}`;
}

export function rememberCampaignView(tabId, campaignId, view) {
  const key = keyFor(tabId, campaignId);
  if (!key || !view?.id) return;
  memory.set(key, { id: view.id, type: view.type || null });
}

export function recallCampaignView(tabId, campaignId) {
  const key = keyFor(tabId, campaignId);
  if (!key) return null;
  return memory.get(key) || null;
}
